import { dateFormat } from "@/utils";



const options = [
  {
    label: "全部",
    value: null,
  },
  {
    label: "基础职位",
    value: 1,
  },
  {
    label: "职位发布数",
    value: 2,
  },
  {
    label: "职位置顶点",
    value: 3,
  },
  {
    label: "简历下载点",
    value: 4,
  },
  {
    label: "职位刷新点",
    value: 5,
  },
  {
    label: "职位省心推",
    value: 6,
  },
]
const getTypeValue = (productType)=>{
  if (productType === 1) {
    return "基础职位";
  } else if (productType === 2) {
    return "职位发布数";
  } else if (productType === 3) {
    return "职位置顶点";
  } else if (productType === 4) {
    return "简历下载点";
  } else if (productType === 5) {
    return "职位刷新点";
  } else if (productType === 6) {
    return "职位省心推";
  }
}
export const tableFormConfig = [
  {
    mold: "select",
    prop: "order_type",
    name: "类型",
    multiple: false,
    emptyEnable: false,
    // searchEnable:true,
    placeholder: "请选择",
    options: [
      {
        label: "全部",
        value: null,
      },
      {
        label: "套餐",
        value: 1,
      },
      {
        label: "产品包",
        value: 2,
      },
    ],
    default: [null],
  },
  {
    mold: "select",
    prop: "service_state",
    name: "状态",
    multiple: false,
    emptyEnable: false,
    // searchEnable:true,
    placeholder: "请选择",
    options: [
      {
        label: "全部",
        value: null,
      },
      {
        label: "待生效",
        value: 1,
      },
      {
        label: "生效中",
        value: 2,
      },
      {
        label: "已过期",
        value: 3,
      },
      {
        label: "提前终止",
        value: 4,
      },
    ],
    default: [null],
  },
  {
    mold: "datepicker",
    type: "datetimerange",
    valueFormat: "yyyy-MM-dd hh:mm:ss",
    format: "yyyy-MM-dd hh:mm:ss",
    prop: "date",
    name: "购买日期",
    startPlaceholder: "开始日期",
    endPlaceholder: "截止日期",
    // default: [getStartMonth(-1),getEndMonth(-1)],
    clearable: true,
  },
  {
    mold: "querybutton",
    name: "搜索",
  },
];

export const columns = [
  {
    label: "购买编号",
    prop: "order_no",
  },
  {
    label: "类型",
    prop: "order_type",
    formatter: function(row) {
      return row["order_type"] === 1 ? "套餐" : "产品包";
    },
  },
  {
    label: "名称",
    prop: "order_name",
  },
  {
    label: "实付金额",
    prop: "price",
    formatter: function(row) {
      return "￥" + row.price;
    },
  },
  {
    label: "状态",
    prop: "service_state",
    formatter: function(row) {
      if (row["service_state"] === 1) {
        return "待生效";
      } else if (row["service_state"] === 2) {
        return "生效中";
      } else if (row["service_state"] === 3) {
        return "已过期";
      } else if (row["service_state"] === 4) {
        return "提前终止";
      }
    },
  },
  {
    label: "生效日期",
    prop: "effect_start_time",
    formatter: function(row) {
      return dateFormat("YYYY-mm-dd", row["effect_start_time"], "string");
    },
  },
  {
    label: "截止日期",
    prop: "effect_end_time",
    formatter: function(row) {
      return dateFormat("YYYY-mm-dd", row["effect_end_time"], "string");
    },
  },
  {
    mold: "customTipsBilling",
    label: "发票进度",
    prop: "invoice_state",
    url: "/recruitment/order_employ/invoice_detail",
    params: function(row) {
      return { order_id: row.id };
    },
    formatter: function(row) {
      if (row["invoice_state"] === 1) {
        return "待开票";
      } else if (row["invoice_state"] === 2) {
        return "开票中";
      } else if (row["invoice_state"] === 3) {
        return "已开票";
      }
    },
    options: [
      [
        {
          label: "发票类型",
          value: "invoice.invoice_type",
          formatter: function({invoice}) {
            if (invoice.invoice_type === 1) {
              return "增值税普票";
            } else if (invoice.invoice_type === 2) {
              return "增值税专票";
            }
          },
        },
        {
          label: "开票名称",
          value: "invoice.invoice_name",
        },
        {
          label: "税号",
          value: "invoice.invoice_code",
        },
      ],
      [
        {
          label: "快递公司",
          value: "express.express_name",
        },
        {
          label: "快递单号",
          value: "express.express_code",
        },
        {
          label: "发出时间",
          value: "express.add_time",
        },
        {
          label: "收件人",
          value: "express.receive_name",
        },
        {
          label: "收件电话",
          value: "express.receive_phone",
        },
        {
          label: "收件地址",
          value: "express.address",
          formatter:(row)=>{
            return row.express.province+row.express.city_name+row.express.area_name+row.express.address;
          }
        },
      ],
    ],
  },
  {
    label: "购买时间",
    prop: "add_time",
  },
];

export const tableFormConfig1 = (a)=>{
  return [
    {
      mold: "select",
      prop: "product_type",
      name: "权益",
      multiple: false,
      emptyEnable: false,
      // searchEnable:true,
      placeholder: "请选择",
      options: options,
      default: [null],
    },
    {
      mold: "select",
      prop: "province",
      name: "地区",
      multiple: false,
      emptyEnable: false,
      // searchEnable:true,
      placeholder: "请选择",
      options: a,
      default: [null],
    },
    {
      mold: "select",
      prop: "service_state",
      name: "状态",
      multiple: false,
      emptyEnable: false,
      // searchEnable:true,
      placeholder: "请选择",
      options: [
        {
          label: "全部",
          value: null,
        },
        {
          label: "待生效",
          value: 1,
        },
        {
          label: "生效中",
          value: 2,
        },
        {
          label: "已过期",
          value: 3,
        },
        {
          label: "提前终止",
          value: 4,
        },
      ],
      default: [null],
    },
    {
      mold: "input",
      prop: "order_no",
      name: "购买编号",
      placeholder: "",
      maxlength: 7,
    },
    {
      mold: "datepicker",
      type: "datetimerange",
      valueFormat: "yyyy-MM-dd hh:mm:ss",
      format: "yyyy-MM-dd hh:mm:ss",
      prop: "date",
      name: "获得日期",
      startPlaceholder: "开始日期",
      endPlaceholder: "截止日期",
      // default: [getStartMonth(-1),getEndMonth(-1)],
      clearable: true,
    },
    {
      mold: "querybutton",
      name: "搜索",
    },
  ];
}

export const columns1 = [
  {
    label: "权益",
    prop: "product_type",
    formatter: function(row) {
      return getTypeValue(row["product_type"]);
    },
  },
  {
    label: "有效区域",
    prop: "province",
    formatter: function(row) {
      return row["province"] ? row["province"] : "全国";
    },
  },
  {
    label: "总数量",
    prop: "total",
  },
  {
    label: "已用",
    prop: "num",
  },
  {
    label: "状态",
    prop: "state",
    formatter: function(row) {
      if (row["state"] === 1) {
        return "待生效";
      } else if (row["state"] === 2) {
        return "生效中";
      } else if (row["state"] === 3) {
        return "已过期";
      } else if (row["state"] === 4) {
        return "提前终止";
      }
    },
  },
  {
    label: "生效日期",
    prop: "effect_start_time",
    formatter: function(row) {
      return dateFormat("YYYY-mm-dd", row["effect_start_time"], "string");
    },
  },
  {
    label: "截止日期",
    prop: "effect_end_time",
    formatter: function(row) {
      if (row["effect_end_time"] === null) {
        return "永久";
      }
      return dateFormat("YYYY-mm-dd", row["effect_end_time"], "string");
    },
  },
  {
    label: "获得方式",
    prop: "get_type",
    formatter: function(row) {
      if (row["get_type"] === 1) {
        return "购买套餐";
      } else if (row["get_type"] === 2) {
        return "购买产品包";
      } else if (row["get_type"] === 3) {
        return "参加产品活动";
      } else if (row["get_type"] === 4) {
        return "管理员分配";
      }else if (row["get_type"] === 5) {
        return "管理员收回";
      }else if (row["get_type"] === 6) {
        return "权益转移";
      }
    },
  },
  {
    label: "关联购买编号",
    prop: "order_no",
  },
  {
    label: "获得时间",
    prop: "add_time",
  },
];
export const tableFormConfig2 = (list)=>{
  list.forEach((item)=>{
    item.label = item.name;
    item.value = item.id;
  })
  list.unshift({
    label: "全部",
    value: null,
  },)
  return [
    {
      mold: "select",
      prop: "product_type",
      name: "权益",
      multiple: false,
      emptyEnable: false,
      // searchEnable:true,
      placeholder: "请选择",
      options: options,
      default: [null],
    },
    {
      mold: "select",
      prop: "use_user_id",
      name: "使用成员",
      multiple: false,
      emptyEnable: false,
      searchEnable: true,
      placeholder: "请选择",
      options: list,
      default: [null],
    },
    {
      mold: "datepicker",
      type: "datetimerange",
      valueFormat: "yyyy-MM-dd hh:mm:ss",
      format: "yyyy-MM-dd hh:mm:ss",
      prop: "date",
      name: "使用日期",
      startPlaceholder: "开始日期",
      endPlaceholder: "截止日期",
      // default: [getStartMonth(-1),getEndMonth(-1)],
      clearable: true,
    },
    {
      mold: "querybutton",
      name: "搜索",
    },
  ];
}

export const columns2 = [
  {
    label: "权益",
    prop: "product_type",
    formatter: function(row) {
      return getTypeValue(row["product_type"]);
    },
  },
  {
    label: "用量",
    prop: "num",
  },
  {
    label: "用途",
    prop: "use_type",
    formatter: function(row) {
      if (row["use_type"]===1) {
        if(row['product_type']===4){
          return `下载${row["download_user"]["name"]}的简历`;
        }else {
          return `{ ${row["employ"]["post"]} | ${row["employ"]["project_name"]} }`;
        }
      } else if (row["use_type"]===2){
        return `管理员分配`;
      }else if (row["use_type"]===3){
        return `管理员回收`;
      }else if (row["use_type"]===4){
        return `权益转移`;
      }
    },
  },
  {
    label: "使用成员",
    prop: "use_user",
    formatter: function(row) {
      return row["use_user"]["recruit_name"];
    },
  },
  {
    label: "使用时间",
    prop: "add_time",
  },
];
